import { render, staticRenderFns } from "./GroupsTreeItem.vue?vue&type=template&id=ee9feea4&scoped=true&"
import script from "./GroupsTreeItem.vue?vue&type=script&lang=js&"
export * from "./GroupsTreeItem.vue?vue&type=script&lang=js&"
import style0 from "./GroupsTreeItem.vue?vue&type=style&index=0&id=ee9feea4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee9feea4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VBadge,VBtn,VFlex,VLayout,VList,VListItem,VListItemTitle,VMenu})
